import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import { Link } from 'react-router-dom'

export class DataSources extends Component {
  constructor (props) {
    super(props)
    this.state = {
      dataSources: [],
      loading: false,
      editing: null,
      showModal: false
    }
  }

  fetchDataSources () {
    return fetch('/api/v1/data_sources', {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          return false
        }

        return data.results
      })
  }

  componentDidMount () {
    this.setState({ loading: true })

    this.fetchDataSources().then(dataSources => {
      this.setState({ loading: false, dataSources })
    })
  }

  edit = (dataSourceId) => {
    this.setState({ editing: dataSourceId })
  }

  cancelEdit = () => {
    this.setState({ editing: null })
  }

  showModal = () => {
    this.setState({ showModal: true })
  }

  hideModal = () => {
    this.setState({ showModal: false })
  }

  render () {
    const { dataSources } = this.state

    return (
      <div className={css.table}>
        <div className={css.tableRow}>
          <div>Name</div>
          <div />
        </div>
        {dataSources.map(dataSource => {
          return (
            <div key={dataSource.id} className={css.tableRow}>
              <div>{dataSource.name}</div>
              <div><Link to={`/data/${dataSource.id}`} className={css.button}>Edit</Link></div>
            </div>
          )
        })}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { auth } = state
  return {
    auth
  }
}

export default connect(mapStateToProps)(DataSources)



// WEBPACK FOOTER //
// /app/js/components/DataSources/index.js